"use client"
import Container from "@/components/Container/Container"
import { useState, useEffect, useRef } from "react"
import { Swiper, SwiperSlide } from "swiper/react"

import LightGallery from "lightgallery/react"
import lgThumbnail from "lightgallery/plugins/thumbnail"
import lgZoom from "lightgallery/plugins/zoom"

import "lightgallery/css/lightgallery.css"
import "lightgallery/css/lg-zoom.css"

// Import Swiper styles
import "swiper/css"
import "swiper/css/navigation"

// import required modules
import { Navigation, Mousewheel } from "swiper"

import Modal from "@/components/Modal/Modal"

import styles from "./Gallery.module.scss"

function chunkArray(initialArray, chunkSize) {
  const resultArray = []
  for (let i = 0; i < initialArray.length; i += chunkSize) {
    const chunk = initialArray.slice(i, i + chunkSize).map((el, index) => ({
      id: i / chunkSize,
      src: el,
      thumb: el,
      size: "1600-2400",
    }))
    resultArray.push(chunk)
  }
  return resultArray
}

const sliderBreakpoints = {
  480: {
    slidesPerView: 2,
  },
  1280: {
    slidesPerView: 3,
  },
}

export default function Gallery({ items }) {
  const resultArray = chunkArray(items, 3)
  const [isModalVisible, setIsModalVisible] = useState(false)
  const [modalSrc, setModalSrc] = useState("")

  const prevRef = useRef(null)
  const nextRef = useRef(null)

  function openImage(el) {
    setIsModalVisible(false)
    setModalSrc(el.thumb)

    setIsModalVisible(true)
  }

  function closeModal() {
    setIsModalVisible(false)
  }

  return (
    <section className={`gallery ${styles.gallery}`}>
      <Swiper
        navigation={true}
        modules={[Navigation, Mousewheel]}
        className={styles.gallery__swiper}
        breakpoints={sliderBreakpoints}
        onInit={(swiper) => {
          swiper.params.navigation.prevEl = prevRef.current
          swiper.params.navigation.nextEl = nextRef.current
          swiper.navigation.init()
          swiper.navigation.update()
        }}
        mousewheel={true}
      >
        {resultArray.map((el, index) => {
          return (
            <SwiperSlide
              key={index}
              className={`${styles.gallery__slide} ${
                el.length === 1
                  ? styles.noGrid
                  : el.length === 2
                  ? styles.twoGrid
                  : ""
              }`}
            >
              {el.map((slide, slideIndex) => {
                return (
                  <img
                    loading="lazy"
                    onClick={() => openImage(slide)}
                    key={`slideImage-${slideIndex}`}
                    className={styles.gallery__item}
                    src={slide.thumb}
                    alt=""
                  ></img>
                )
              })}
            </SwiperSlide>
          )
        })}
        <div className={styles.gallery__navbtns}>
          <Container className={styles.gallery__navcontainer}>
            {/* Custom navigation buttons */}
            <div
              className={`gallery__nav swiper-button-prev ${styles.gallery__nav} ${styles.prev}`}
              ref={prevRef}
            ></div>
            <div
              className={`gallery__nav swiper-button-next ${styles.gallery__nav} ${styles.next}`}
              ref={nextRef}
            ></div>
          </Container>
        </div>
      </Swiper>
      {isModalVisible && <Modal image={modalSrc} close={closeModal} isImage />}
    </section>
  )
}
